<template>
  <div class="zt-editor">
    <TinymceVue
      v-model="valueModel"
      :init="tinymceEditorInit"
      v-bind="$attrs"/>
  </div>
</template>

<script>
import tinymce from 'tinymce'
import TinymceVue from '@tinymce/tinymce-vue';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/image';
import 'tinymce/plugins/link';
import 'tinymce/plugins/fullscreen';
import tinymceEditorInit from '@/components/ZtEditor/tinymceEditorInit';

export default {
  name: 'ZtEditor',
  components: {
    TinymceVue,
  },
  props: {
    value: String,
  },
  computed: {
    valueModel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  data() {
    return {
      tinymceEditorInit,
    }
  },
  methods: {

  },
  mounted() {
    tinymce.init({});
  },
};
</script>

<style lang="scss">
.zt-editor {

}
</style>
